'use client';

import { AUTH_SWITCH_COOKIE } from './constants/auth-switch-cookie';
import { AUTH_SWITCH_MAX_AGE_SECONDS } from './constants/auth-switch-max-age-seconds';

/**
 * Set auth switch cookie (client-side)
 * Signals that an auth switch is in progress
 */
export function setAuthSwitchCookie(): void {
  document.cookie = `${AUTH_SWITCH_COOKIE}=1; path=/; max-age=${AUTH_SWITCH_MAX_AGE_SECONDS}; SameSite=Lax`;
}
